const LanguageEnum = {
    ENG: 'English',
    CRO: 'Croatian'
  };

export default LanguageEnum;